import styled from "styled-components";
import { THEME } from "utils/theme";

export const ChatRoot = styled.div<{ fullHeight?: boolean }>`
  height: ${(p) => (p.fullHeight ? "100svh" : `calc(100vh - ${THEME.appbarHeight.workspace}px)`)};
  display: flex;
  flex-direction: column;
  position: relative;
`;
